import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import Button from 'common/components/elements/buttons/primary'
import Icon from 'common/components/elements/icons'
import { MediaChip, MediaButton, MediaLableItem } from 'common/components/modules/media'
import { BlurhashCanvas } from "react-blurhash";
import { Link } from 'react-router-dom';
// import IconLabel from 'common/components/elements/icon-label';
import './style.scss';
import cx from "classnames";
import Button from 'common/components/elements/buttons/primary';
import TruncateText from 'common/components/elements/truncate-text';
import DateFormatter from 'common/utils/DateFormatter';
import PreviewVideo from 'sites/views/media-modules/preview-video';


const blurhash = require('blurhash');

const MessageWrapper = ({
   children,
   unlockButton,
   wrapperClassNames,
   openAttachmentsModal,
   classNames,
}) => {
   return (
      <div className={ wrapperClassNames } role='presentation' onClick={ openAttachmentsModal }>
         <div className={ classNames }>
            {children}
         </div>
         {
            unlockButton
         }
      </div>
   )
}


const MultipleAttachmentMessage = ({
   data = {},
   isAdmin,
   contentLink,
   onStream,
   closeChat,
   paymentButtonLoading,
   width = '250px',
   adminMessage,
   attachments,
   isMiniChat,
   onClickAttachment,
   onRemoveMedia,
   isGroup,
   isParent = false,
   isMobile,
}) => {

   const openAttachmentsModal = (e) => {
      e.stopPropagation()
      !!onClickAttachment && onClickAttachment(e)
   }

   const wrapperClassNames = cx({
      'flex gap-2': true,
      'hover:cursor-pointer': !!onClickAttachment,
      'flex-col': !isAdmin,
   })

   const classNames = cx({
      'flex gap-2': true,
      'hover:cursor-pointer': !!onClickAttachment && isAdmin,
   })

   const staticProps = {
      isAdmin,
      adminMessage,
      paymentButtonLoading,
      onStream,
      unlockDetails: data,
      width: window.innerWidth < 445 ? '110px' : '143px',
      onRemoveMedia: (content, index) => onRemoveMedia(content, index),
      isUnlocked: data?.is_unlocked,
      isMessage: true,
      contentLink,
      closeChat,
      isMobile,
   }



   const unlockButton = (
      !isAdmin && !isGroup && ('is_unlocked_for_view' in data ? !data?.is_unlocked_for_view : !data?.is_unlocked) && !!data?.unlock_price && !!data?.attachments?.length &&
      <Button
         text={ `Unlock for ${ data?.unlock_price } USD` }
         textSize='small'
         iconName={ !paymentButtonLoading ? 'unlocked-new' : '' }
         iconPosition='left'
         fontIconSize='base'
         primaryColor
         classNames='w-auto !h-9 px-3'
         padding='none'
         onClick={ (e) => {
            e.stopPropagation()
            console.log('Unlock')
            onStream()
         } }
         borderRadius='large'
         isLoading={ paymentButtonLoading }
      />
   )

   const messageWrapperStaticProps = {
      unlockButton,
      wrapperClassNames,
      openAttachmentsModal,
      classNames,
   }

   if(isParent) {

      if(attachments.length === 1) {

         return (
            <MessageWrapper
               { ...messageWrapperStaticProps }
            >
               {
                  attachments.map((content, index) => {
                     return (
                        <MessageElement
                           key={ index }
                           index={ index }
                           content={ content }
                           isParent
                           { ...staticProps }
                        />
                     )
                  }
                  )
               }
            </MessageWrapper>
         )
      }

      if(attachments.length > 1) {

         return (
            <MessageWrapper
               { ...messageWrapperStaticProps }
            >
               {
                  attachments.slice(0, isMiniChat ? 1 : 2).map((content, index) => {
                     return (
                        <MessageElement
                           key={ index }
                           content={ content }
                           index={ index }
                           contentCountLeft={ attachments.length - (isMiniChat ? 1 : 2) }
                           isParent
                           hideCount={ !isMiniChat && index === 0 }
                           { ...staticProps }
                        />
                     )
                  })
               }
            </MessageWrapper>
         )
      }
   }

   if(attachments.length < 3) {

      return (
         <MessageWrapper
            { ...messageWrapperStaticProps }
         >
            {
               attachments.map((content, index) => {
                  return (
                     <MessageElement
                        key={ index }
                        content={ content }
                        index={ index }
                        { ...staticProps }
                        width={ attachments.length === 1 ?  (window.innerWidth < 445 ? '210px' : '250px') : staticProps.width }
                     />
                  )
               }
               )
            }
         </MessageWrapper>
      )
   }

   if(attachments.length >= 3) {

      if(isMiniChat || (!isAdmin) || (window?.innerWidth > 1280 && window?.innerWidth < 1380) || (window?.innerWidth < 530)) {

         return (
            <MessageWrapper
               { ...messageWrapperStaticProps }
            >
               {
                  attachments.slice(0, 2).map((content, index) => {
                     return (
                        <MessageElement
                           key={ index }
                           content={ content }
                           index={ index }
                           contentCountLeft={ attachments.length - 2 }
                           lastMediaIndex={ 1 }
                           { ...staticProps }
                        />
                     )
                  })
               }
            </MessageWrapper>
         )

      }

      return (
         <MessageWrapper
            { ...messageWrapperStaticProps }
         >
            {
               attachments.slice(0, 3).map((content, index) => {
                  return (
                     <MessageElement
                        key={ index }
                        content={ content }
                        index={ index }
                        contentCountLeft={ attachments.length - 3 }
                        lastMediaIndex={ 2 }
                        { ...staticProps }
                     />
                  )
               })
            }
         </MessageWrapper>
      )
   }
};


export const MessageElement = ({
   content,
   width,
   isAdmin,
   unlockDetails,
   adminMessage,
   onStream,
   paymentButtonLoading,
   contentCountLeft,
   index,
   lastMediaIndex,
   isUnlocked,
   onRemoveMedia,
   title,
   onClickItem,
   hasDetailsPage,
   isMessage,
   siteInfo,
   contentStatus,
   isParent,
   contentLink,
   closeChat,
   hideCount,
   isMobile,
}) => {

   let cover = content?.cover || '';
   let isVideo = 'video_unlock' === content?.type;
   let hash = null
   let style = {}
   const isBlockForMember = !isAdmin && !(unlockDetails.is_unlocked || !unlockDetails.unlock_price || !!cover)

   const isMediaBlurApplied = (
      (content?.resource_type === 'video' || content?.resource_type === 'photoset') && content?.locked_image_is_blur
   ) ||
    (
       (content?.resource_type === 'video_vault' || content?.resource_type === 'photo_vault') && unlockDetails?.locked_poster_is_blur
    )

   const showBlurhash = !isAdmin && isMediaBlurApplied && !!content?.blurhash && contentStatus !== 'locked_free_content' && isBlockForMember && !content?.cover

   let contentStyles = {}


   if(!!content?.cover && !showBlurhash) {
      cover = content.cover;
      if(!!content?.cover_thumb) {
         cover = content.cover_thumb;
      }
      style = {
         ...style,
         backgroundImage: `url(${ cover }`,
      }

      if(isAdmin  || !isBlockForMember) {
         style = {
            ...style,
            filter: 'blur(10px)',
         }

      }
   }

   if(showBlurhash) {
      const { result } =  blurhash.isBlurhashValid(content.blurhash)
      if(result) {
         hash = content.blurhash
      } else {
         hash = 'UBF6UmB._3.S?^4TIARj00H?IUVsrX%#%Mxu'
      }

   }

   if(!!cover && (!isBlockForMember || (!isAdmin && (!content?.locked_image_is_blur || !unlockDetails.locked_poster_is_blur)))) {
      style = {
         ...style,
         filter: 'blur(10px)',
      }

   }

   if(((!hideCount && isParent && contentCountLeft > 0) || (!!index && index === lastMediaIndex)) && !!contentCountLeft) {

      contentStyles = {
         background: `linear-gradient(0deg, #041527, #041527), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))`,
         opacity: '0.6',
      }
   }

   if(isUnlocked && isAdmin && !isMessage) {

      contentStyles = {
         background: `rgba(0, 0, 0)`,
         opacity: '0.6',
      }
   }

   const previewSrc = content?.system_preview_video_full_src || content?.custom_preview_video_full_src
   // || 'https://staging-cdn.adultmembersites.com/videos/qysUR5k9P9AWgSmHg9800vHEK7NJaUEc/outputs/preview/system2.mp4?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6XC9cL3N0YWdpbmctY2RuLmFkdWx0bWVtYmVyc2l0ZXMuY29tXC92aWRlb3NcL3F5c1VSNWs5UDlBV2dTbUhnOTgwMHZIRUs3TkphVUVjXC9vdXRwdXRzXC9wcmV2aWV3XC9zeXN0ZW0yLm1wNCIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTczOTAwMjY0OH19fV19&Signature=mb-P41PexIwjSx6bsX6mZr0K8hLqolF47FoB-7hb7FC~cJm30Y7DW04e1Pf0sVgygcXONtjrIct09C9Ptyj1GuU7oUB4NWj~j5Q-clJs1JdYmIf8m1UHmebM9DuF5DtkAu8fRvym4wwDDFP3x2U8rWI-e2RPyoG~PmBZ7Chw3HVIPsbHTZJYeVXgSfOjjUyAsNAYgC5GBuZxg-g4~mkOQbJcMk6lmIUNzOWelSC~XnKu17G9Xu0N8H3yk75TSNMnOR22ev2Sz0CDzYyV4g5g8BMxmPchn9HrqKvfoU43OdW~y0fTifkErSYsojfLYTOMGpP3pTWCPOyjwexgs89daQ__&Key-Pair-Id=KTUJLALS4K9CN'
   const [isAutoPlay, setIsAutoPlay] = useState(false);
   let showContentCount = ((!hideCount && isParent && contentCountLeft > 0) || (!!index && index === lastMediaIndex)) && !!contentCountLeft

   const canPlayPreview = () => {
      if(showContentCount) return false
      if(!isMobile) {
         return isAutoPlay;
      }
      return true
   }


   const view = <>
      <div
         className={ cx({
            'flex flex-col': true,
            [`cursor-pointer`]: hasDetailsPage,
         }) }
         style={ {
            width,
         } }
      >
         <div
            style={ {
               width,
               aspectRatio: '16 / 9',
            } }
            className={ cx({
               'flex flex-col items-center justify-center relative overflow-hidden **aspect-ratio-padding z-1': true,
               [`rounded-lg`]: true,
            }) }
            role='presentation'
            onClick={ (e) => {
               if(!hasDetailsPage) {
                  return
               }
               !!onClickItem && onClickItem()
            } }
            onMouseEnter={ () => {
               if(!!previewSrc && !isMobile && /video/.test(content?.resource_type)){
                  setIsAutoPlay(true)
               }
            } }
            onMouseLeave={ () => {
               if(!!previewSrc && !isMobile && /video/.test(content?.resource_type)){
                  setIsAutoPlay(false)
               }
            } }
            id='media-layer'
         >

            {
               !!previewSrc &&
            canPlayPreview() &&
            <div className='absolute top-0 left-0 w-full h-full z-2'>
               <PreviewVideo
                  // showFullScreenButton
                  previewSrc={ previewSrc }
                  // showVolumeButton={ Boolean(data?.custom_preview_video_full_src) }
                  poster={ cover }
                  // voiceIconRightPosition={ 16 }
                  videoId={ content?.resource_id || content?.vaultId }
                  // isContentCard
                  // setOpenFullScreen={ _ => {
                  //    if(!!previewSrc && !isMobile){
                  //       setIsAutoPlay(false);
                  //    }
                  // } }
                  // openFullscreen={ openFullscreen }
               />
            </div>
            }

            {
               !isAdmin && !isMessage && unlockDetails?.allow_download && (
                  <div
                     className='flex  absolute left-0 top-0 items-center justify-center z-[11] m-2'
                  >
                     <MediaLableItem
                        iconName='download'
                        tooltipContent={ isBlockForMember ? 'Download after unlock' : 'Download allowed' }
                     />

                  </div>
               )
            }
            {
               isAdmin && !isMessage && !(!!index && index === lastMediaIndex) &&  !isUnlocked && !!onRemoveMedia && (
                  <div
                     className={ cx({
                        'media-item-remove absolute top-0 right-0 m-2 flex rounded-lg items-center justify-center z-10 cursor-pointer': true,
                     }) }
                  >
                     <MediaButton
                        onClick={ (e) => {
                           e.stopPropagation()
                           e.preventDefault()
                           if(['photo_vault', 'video_vault'].includes(content?.resource_type)){
                              onRemoveMedia({ ...content, attachments: unlockDetails?.attachments }, index)
                           } else {
                              onRemoveMedia(content, index)
                           }
                        } }
                        iconName='cancel'
                        dataToolTipContent='Unsend'
                     />
                  </div>

               )
            }

            {
               !!cover && (!isBlockForMember || (!isAdmin && (!content?.locked_image_is_blur || !unlockDetails.locked_poster_is_blur))) && (
                  <img src={ cover } alt='' className='w-full h-full object-contain object-center absolute inset-0 z-1' />
               )
            }
            <div
               style={ {
                  ...style,
               } }
               className='bg-cover bg-center bg-no-repeat w-full h-full absolute inset-0 z-0'
            >
               {
                  showBlurhash && !!hash && (
                     <BlurhashCanvas
                        hash={ hash }
                        punch={ 1 }
                        className='h-full w-full rounded-lg'
                     />
                  )
               }
            </div>
            <div
               className='m-1 z-2 absolute bottom-0 left-0'
            >
               <MediaChip
                  type={ isVideo ? 'video' : 'photoset' }
                  countOrDuration={ isVideo ? content?.video_duration : content?.photos_count }
                  name=''
                  photoIcon='photosets'
               />
            </div>
            <div
               className={ `absolute w-full flex items-center justify-center h-full z-2 ` }
               style={ { ...contentStyles } }
            >
               {
                  (((isParent && contentCountLeft > 0) || !(!!index && index === lastMediaIndex))) && !isAdmin && showBlurhash && isBlockForMember &&
                  <Icon
                     size={ isMessage ? '[32px]' : '[80px]' }
                     name='lock'
                     className={ `${ isMessage ? 'text-[32px]' : 'text-[80px]' } text-[#FFFFFF99] dark:text-[#FFFFFF99] ` }
                     darkColor='#FFFFFF99'
                     style={ {
                        opacity: '.9',
                     } }
                  />
               }

            </div>
            {
               showContentCount &&
               <span className='text-major-dark z-[5]'>
                  { '+' + contentCountLeft}
               </span>
            }
            {
               isAdmin &&  !isMessage && isUnlocked &&
               <div className='flex z-[5] items-center justify-center gap-1'>
                  <Icon
                     name={ 'unlocked-new' }
                     color='success'
                     darkColor='success-dark'
                     size={ `xl` }
                  />
                  <p className='text-base text-success dark:text-success-dark leading-[18px]'>
                     Unlocked
                  </p>
               </div>
            }
         </div>
         {
            title &&
            <div className='flex flex-col mt-2 gap-0.5'>
               <div className='w-full flex items-center gap-1.5'>
                  {
                     Boolean(false)  &&
                     <Icon
                        name={ `pin` }
                        color={ `warning` }
                        darkColor={ `warning-dark` }
                        className={ `h-5 w-5 min-h-[20px] min-w-[16px] rotate-[35deg] mt-0.5` }
                        size={ `xl` }
                        data-tooltip-content={ 'Pinned' }
                        data-tooltip-id={ 'ams-top-tooltip' }
                     />
                  }
                  <TruncateText
                     text={ title }
                     textClass='text-xl leading-6 font-bold text-major dark:text-major-dark title dark:shadow-none'
                     textSize='20px'
                     fontWeight='700'
                  />
               </div>
               {
                  !!content?.publish_date &&
                  <span className='panel-description leading-4 text-placeholder dark:text-placeholder-dark font-normal description text-left'>
                     {
                        ['video', 'photoset'].includes(content?.resource_type) && siteInfo?.content_card_settings?.timestamp ? (content?.resource_type === 'video' ? ' Video • ' : 'Photoset • ') : ''}
                     {
                        ['video', 'photoset'].includes(content?.resource_type) && siteInfo?.content_card_settings?.timestamp &&  DateFormatter.getDate(content?.publish_date)
                     }
                  </span>
               }
            </div>
         }
      </div>
   </>


   if(!isMessage && !!(contentLink())) {
      return   <Link
         onClick={ () => {
            if(closeChat) {
               closeChat()
            }

         } }
         to={ contentLink() } >
         {view}
      </Link>
   } else {
      return  view
   }

}


MultipleAttachmentMessage.propTypes = {
   data: PropTypes.object,
   isAdmin: PropTypes.bool,
   onStream: PropTypes.func,
   closeChat: PropTypes.func,
   paymentButtonLoading: PropTypes.bool,
   width: PropTypes.string,
   contentLink: PropTypes.any,
   adminMessage: PropTypes.bool,
   attachments: PropTypes.array,
   isMiniChat: PropTypes.bool,
   onClickAttachment: PropTypes.func,
   onRemoveMedia: PropTypes.func,
   isGroup: PropTypes.bool,
   isParent: PropTypes.bool,
   hasDetailsPage: PropTypes.bool,
   isMobile: PropTypes.bool,
};

MessageElement.propTypes = {
   content: PropTypes.object,
   width: PropTypes.any,
   isAdmin: PropTypes.bool,
   unlockDetails: PropTypes.object,
   adminMessage: PropTypes.bool,
   onStream: PropTypes.func,
   paymentButtonLoading: PropTypes.bool,
   contentCountLeft: PropTypes.number,
   index: PropTypes.number,
   lastMediaIndex: PropTypes.number,
   isUnlocked: PropTypes.bool,
   onRemoveMedia: PropTypes.func,
   title: PropTypes.string,
   onClickItem: PropTypes.func,
   hasDetailsPage: PropTypes.bool,
   isMessage: PropTypes.bool,
   siteInfo: PropTypes.object,
   contentStatus: PropTypes.string,
   isParent: PropTypes.bool,
   contentLink: PropTypes.func,
   closeChat: PropTypes.func,
   hideCount: PropTypes.bool,
   isMobile: PropTypes.bool,
};

MessageWrapper.propTypes = {
   children: PropTypes.any,
   unlockButton: PropTypes.any,
   wrapperClassNames: PropTypes.string,
   openAttachmentsModal: PropTypes.func,
   classNames: PropTypes.string,
};

export default MultipleAttachmentMessage;
